import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';
import { c as classNames } from './index-8a7d9ef9.js';
import * as React from 'react';

var styles = {"circleIcon":"CircleIcon_circleIcon_856be465"};

var CircleIcon = React.forwardRef(function CircleIcon(_a, ref) {
    var icon = _a.icon, backgroundColor = _a.backgroundColor, color = _a.color, className = _a.className, otherProps = __rest(_a, ["icon", "backgroundColor", "color", "className"]);
    var IconComponent = icon;
    return (React.createElement("div", { className: classNames(styles.circleIcon, className), style: { backgroundColor: backgroundColor }, ref: ref, "data-testid": "circle-icon" },
        React.createElement(IconComponent, __assign({ fillColor: color ? color : "white" }, otherProps))));
});

export { CircleIcon as C };
